module.exports = __webpack_public_path__ + "static/archon_of_falling_stars-c45fe745815042df30e27b2292a26601.jpg";